var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$store.state.visible == true)?_c('div',{attrs:{"id":"home"}}):_c('div',{attrs:{"id":"homeMobile"}})])}
var staticRenderFns = []

export { render, staticRenderFns }